import './HomeCertificate.css';
import { Component } from 'react';
import { Box, Typography, Rating, TextField, Button, Paper } from "@mui/material";
import axios from 'axios';
import { RotatingLines } from "react-loader-spinner";
import { Navigate } from 'react-router';

// Internal Imports
import { messages, options,severProperties } from './utility/Constants';
import addHookTo from './AddHookTo';
import HeaderMenu from './HeaderMenu';
import { getToken, getRefreshToken, getLocaleLanguage } from './AuthService';

import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { FormattedMessage, IntlProvider } from 'react-intl';

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "80%",
    marginTop: "5%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  popup: {
    background: "white",
    padding: "30px",
    borderRadius: "10px",
    textAlign: "center",
    width: "600px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.3)"
  },
  tick: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    background: "#4CAF50",
    color: "white",
    fontSize: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 15px auto"
  }
};

const QUESTIONS = [
  { id: "q1", text: <FormattedMessage id="question1" />},
  { id: "q2", text: <FormattedMessage id="question2" /> },
  { id: "q3", text: <FormattedMessage id="question3" /> },
  { id: "q4", text: <FormattedMessage id="question4" /> },
  { id: "q5", text: <FormattedMessage id="question5" /> },
  { id: "q6", text: <FormattedMessage id="question6" /> },
  { id: "q7", text: <FormattedMessage id="question7" /> },
  { id: "q8", text: <FormattedMessage id="question8" /> }
];

/*const surveyData = {
    "surveyId": "JPETS104",
    "referenceId": "PHJP202600000699",
    "emailId": "guy8869@maildrop.cc",
    "gender": "M",
    "question1Rating": 5,
    "question2Rating": 5,
    "question3Rating": 5,
    "question4Rating": 5,
    "question5Rating": 5,
    "question6Rating": 5,
    "question7Rating": 5,
    "question8Rating": 5,
    "comments": "test"
};*/

const ratingLabels = {
  1: <FormattedMessage id="verypoor" />, 2: <FormattedMessage id="poor" />, 3: <FormattedMessage id="average" />, 4: <FormattedMessage id="good" />, 5: <FormattedMessage id="excellent" />
};

class Communication extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locale: getLocaleLanguage(),
      loading: true,
      dataField: [],
      surveyData:[],
      ratings: {
        q1: 0, q2: 0, q3: 0, q4: 0, q5: 0, q6: 0, q7: 0, q8: 0
      },
      comments: '',
      showPopup: false,
    };
    this.handleLanguageChange = this.handleLanguageChange.bind(this);
  }

  componentDidMount() {
    this.setState({ dataField: [], loading: true });
    this.setState({ surveyData: ''});
    this.fetchData();
    this.fetchSurvey(sessionStorage.getItem('applicationId'));
  }

  fetchData = async () => {
    const token = getRefreshToken(); // Replace with your actual token
    const apiUrl = [severProperties.serverURL,"/applicant/application"].join("");//'http://localhost:8084/applicant/application'; // Replace with your API URL

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Access-Control-Allow-Origin': severProperties.serverCORS,
        },
      });
      this.setState({ dataField: response.data, loading: false });
    } catch (error) {
      if(error.message === "Network Error")
        {
            alert("Session Expired or Invalid");
            this.props.navigate('/');
        }
        else
        {
          alert("Session Expired or Invalid");
          this.props.navigate('/');        
        }
    }
  };

   fetchSurvey = async (aplApplicationId) => {
    const token = getRefreshToken(); // Replace with your actual token
    const apiUrl = [severProperties.serverURL,"/survey/getSurvey?aplReferenceId="+aplApplicationId].join("");//'http://localhost:8084/applicant/application'; // Replace with your API URL

    try {
      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Access-Control-Allow-Origin': severProperties.serverCORS,
        },
      });
      this.setState({ surveyData: response.data, loading: false });
    } catch (error) {
      if(error.message === "Network Error")
        {
            alert("Session Expired or Invalid");
            this.props.navigate('/');
        }
        else
        {
          alert("Session Expired or Invalid");
          this.props.navigate('/');        
        }
    }
  };

  componentWillUnmount() {
    this.setState({ locale: getLocaleLanguage() });
  }


  handleLanguageChange = (e) => {
    const newLang = e.target.value;
    this.setState({ locale: newLang });
    localStorage.setItem('laguagePrefered', newLang);
  };

  // Dynamically update the specific question in the ratings object
  handleRatingChange = (questionId, newValue) => {
    this.setState(prevState => ({
      ratings: {
        ...prevState.ratings,
        [questionId]: newValue
      }
    }));
  };

  handleCommentChange = (event) => {
    this.setState({ comments: event.target.value });
  };

  handleSurvey = async (e,aplreferenceId,gender,email,applicationId) => {
    document.getElementById("feedbackform").style.display = 'block';
    const { ratings, comments } = this.state;
     const token = getRefreshToken(); 
    // Create a comma-separated string of the values (1,2,3,4,5,4,3,2)
    const ratingValues = QUESTIONS.map(q => ratings[q.id]).join(',');

    if (Object.values(ratings).some(val => val === 0 || val === '')) {
      alert("Please provide a rating for all questions before submitting.");
      return;
    }

    let formData = new FormData();
    formData.append('aplReferenceId', aplreferenceId);
    formData.append('gender', gender);
    formData.append('email', email);
    formData.append('surveyString', ratingValues);
    formData.append('comments', comments);
    formData.append('applicationId',applicationId);

    let status;
    if (aplreferenceId !== "" && ratingValues !== "") {
      
      fetch([severProperties.serverURL,"/survey/updateSurvey"].join(""), {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          'Access-Control-Allow-Origin': severProperties.serverCORS,
          'Access-Control-Allow-Methods': 'POST'
        },
        body: formData,
      })
        .then((response) => { status = response.status; return response.text(); } )
        .then((result) => {
      if (status=== 200)
      {
        document.getElementById("feedbackform").style.display = 'none';
      this.setState({ showPopup: true });
      }    

           if (status=== 412 || status=== 403 || status!== 200 || result === "") {
            alert("Unable to update survey");
          }
        }).catch((error)=>{
          alert("We're experiencing connectivity issues. Please check your network settings or try again later. If the problem persists, contact support for assistance."); 
        });
    }

    //console.log("Survey Response String:", ratingValues);
    //console.log("Comments:", comments);
    //alert(`Thank you for your feedback! `);
   // window.location.reload();
    //this.fetchSurvey(aplreferenceId);
  };
  
  closePopup = () => {
    this.setState({ showPopup: false });
     //document.getElementById("feedbackform").style.display = 'block';
     window.location.reload();
  };

  render() {
    const { loading, dataField,surveyData, ratings, comments } = this.state;

    if (getToken() === "" || getToken() === null) {
      return <Navigate to="/" />;
    }
    
    if (loading && !dataField) {
      return (
        <div style={{ display: 'flex', height: '100vh', width: '100vw', justifyContent: 'center', alignItems: 'center' }}>
          <RotatingLines strokeColor="grey" strokeWidth="5" animationDuration="0.75" width="96" visible={true} />
        </div>
      );
    }

    return (
      <div className={`app ${loading ? 'blurred' : ''}`}>
      <IntlProvider locale={this.state.locale}
        messages={messages[this.state.locale]} defaultLocale="en" onError={(error) => { /* Handle missing message... */ }}>
          <div style={{ width: '100vw' }}>
            <HeaderMenu />
           <center style={{ marginTop: 20 }}> 
              
          <FormControl variant="standard" sx={{ m: 1, minWidth: 220 }}>
       
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          value={this.state.locale}
          onChange={this.handleLanguageChange}
          label="Language"
        >
          {options.map(option =>
              (
                 <MenuItem value={option.value} key={option.index}>{option.label}</MenuItem>
              )
            )
            }
          </Select>
      </FormControl>
          </center>
      
            <div  style={{ margin: '20px',marginBottom:'60px' }} id="feedbackform">
	            
              <Paper elevation={3} sx={{ p: 4, maxWidth: 900, mx: "auto" }}>
                <Typography variant="h5" gutterBottom>
                  {<FormattedMessage id="surveytag" />}
                </Typography>
                 <Typography variant="body2" color="text.secondary" mb={3}>
                  {<FormattedMessage id="note1" />}
                 </Typography>

                <Typography variant="body2" color="text.secondary" mb={3}>
                  {<FormattedMessage id="note2" />}
                </Typography>

    
	{surveyData ? (
	  <>
		{QUESTIONS.map((q, index) => (
		  <Box key={q.id} mb={3}>
			<Typography variant="body1" mb={1}>
			  {index + 1}. {q.text}
			</Typography>

			<Box display="flex" alignItems="center" gap={2}>
			  <Rating
				name={q.id}
				value={surveyData[`question${index + 1}Rating`] || 0}
				readOnly
			  />

			  <Typography
				variant="body2"
				sx={{ fontWeight: "bold", color: "#1976d2" }}
			  >
				{ratingLabels[surveyData[`question${index + 1}Rating`]]}
			  </Typography>
            
			</Box>
		  </Box>
		))}

		<Box mb={3}>
		  <Typography variant="body1" mb={1}>
			9. <FormattedMessage id="question9" />
		  </Typography>

		  <TextField
			multiline
			rows={4}
			fullWidth
			value={surveyData.comments || ""}
			disabled
		  />
		</Box>
		
		<h5>Respondent:</h5>
		<h6>
		  Reference ID : {surveyData.referenceId}
		  <br />
		  Sex : {surveyData.gender}
		</h6>

	  </>
) : (
  <>
    {QUESTIONS.map((q, index) => (
      <Box key={q.id} mb={3}>
        <Typography variant="body1" mb={1}>
          {index + 1}. {q.text}
        </Typography>

        <Box display="flex" alignItems="center" gap={2}>
          <Rating
            name={q.id}
            value={ratings[q.id]}
            onChange={(event, newValue) =>
              this.handleRatingChange(q.id, newValue)
            }
          />

          {ratings[q.id] > 0 && (
            <Typography
              variant="body2"
              sx={{ fontWeight: "bold", color: "#1976d2" }}
            >
              {ratingLabels[ratings[q.id]]}
            </Typography>
          )}
        </Box>
      </Box>
    ))}

    <Box mb={3}>
      <Typography variant="body1" mb={1}>
        9. <FormattedMessage id="question9" />
      </Typography>

      <TextField
        multiline
        rows={4}
        fullWidth
        value={comments}
        onChange={this.handleCommentChange}
        placeholder="Your suggestions..."
      />
    </Box>
   {
      this.state.dataField.slice(0,1).map(app =>
        <>
          <h5>Respondent:</h5>
          <h6>
            Reference ID : {app.referenceId}
            <br />
            Sex : {app.applicantGender}
            {sessionStorage.setItem("applicationId",app.applicationId)}
          </h6>

          <center>
            <Button
              variant="contained"
              size="large"
              color="primary"
              onClick={(e) =>
                this.handleSurvey(
                  e,
                  app.referenceId,
                  app.applicantGender,
                  app.applicantEmail,
                  app.applicationId
                )
              }
            >
              <FormattedMessage id="submitfeedback" />
            </Button>
          </center>
        </>
      )}
    </>

              
	      )}
        </Paper>
            </div>
          {this.state.showPopup && (
          <div style={styles.overlay}>
            <div style={styles.popup}>
              <div style={styles.tick}>✓</div>
              <h3>{<FormattedMessage id="thankyou" />}</h3>
              <p>{<FormattedMessage id="feedbacksubmitted" />}</p>
              <Button onClick={this.closePopup}  variant="contained"  color="primary" size="medium">{<FormattedMessage id="editfeedback" />}</Button>
            </div>
          </div>
          
        )}

           
</div>
            <div className="footer" style={{ textAlign: 'center'}}>
              <p>© 2025 IOM. All rights reserved. version 1.0.0 </p>
            </div>
          
          </IntlProvider>
      </div>
    );
  }
}

export default addHookTo(Communication);